import { NgModule } from '@angular/core';
import { AttensaEditorComponent } from './attensaEditor.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        EditorModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        AttensaEditorComponent
    ],
    exports: [
        AttensaEditorComponent
    ]
})
export class AttensaEditorModule {
}